import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";
import Cache from "i18next-localstorage-cache";
import LngDetector from "i18next-browser-languagedetector";

/**
 * i18n Namespaces
 */
export const I18N_NS = {
  ADMIN: "admin",
  GROUPS: "groups",
  WORKFLOW: "workflow",
  SUPPORT: "support",
  GENERAL: "general",
  LOGIN: "login",
  CALENDAR: "calendar",
  PROJECT: "project",
  VALIDATION: "validation",
  PROJECT_SETTINGS: "projectSettings",
  USER_SETTINGS: "userSettings",
  PAGE_404: "404",
  TENDER: "tender",
  QA: "qa",
  MEETINGS: "meetings",
  XKT_VIEWER: "xktViewer",
  RICH_EDITOR: "richEditor",
  COMPONENT_UPLOAD: "componentUpload",
};

const backendLocalesPath =
  process.env.NODE_ENV === "development"
    ? `/locales/{{lng}}/{{ns}}.json`
    : `/${window.GLOBAL.API_BASE}/locales/{{lng}}/{{ns}}.json`;

/**
 * i18n Configuration
 */
export const i18nextOptions: InitOptions = {
  debug: false,
  lng: localStorage.getItem("i18nextLng") ? localStorage.getItem("i18nextLng").toLowerCase() : "de",
  fallbackLng: false,

  nsSeparator: ":::",
  keySeparator: "::",
  ns: Object.values(I18N_NS),
  load: "currentOnly",
  backend: {
    loadPath: backendLocalesPath,
  },
  react: {
    // wait: true,
    nsMode: "fallback",
    useSuspense: true,
  },
  saveMissing: !!import.meta.env.VITE_I18_DEBUG || false,
  missingKeyHandler: async (lng, ns, key, fallbackValue) => {
    if (process.env.NODE_ENV === "development" && import.meta.env.VITE_I18_DEBUG === "true") {
      console.warn("MISSING:", JSON.stringify({ [ns]: key }));

      await fetch(
        "http://localhost:3010/",
        // tslint:disable-next-line: max-line-length
        {
          body: `${window.location.pathname}_:::_${ns}_:::_${key}_:::_${fallbackValue}`,
          method: "POST",
          mode: "no-cors",
        }
      );
    }
  },
};

/**
 * i18next Initialization Object
 */
export const i18nConfig = i18n.use(LngDetector).use(XHR).use(Cache).use(initReactI18next).init(i18nextOptions);

export default i18n;
